import { useContext, useEffect, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import { FormContext } from 'Components/Hooks/ContextForm'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import CustomButton from 'Components/UI/Atoms/CustomButton'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import { logo } from 'Helpers'
import { interfaces } from 'service/interfaces'

import { styles } from './styles'

const Stock = () => {
  const classes = styles()
  const createDismissableSnackbar = useCustomSnackbar()
  const [edit] = useContext(EditContext)
  const [isLoading, setIsLoading] = useState(false)
  const { formEdit, setFormEdit } = useContext(FormContext)

  useEffect(() => {
    async function apiCall() {
      await interfaces.vehicleInterface.getVehiclesStock(formEdit.vehicle.id).then((res) => {
        setFormEdit({ ...formEdit, stock: res.data.data, stockApi: true })
      })
    }
    !formEdit.stockApi && apiCall()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClick = async () => {
    setIsLoading(true)
    await interfaces.vehicleInterface
      .getTransferedStock(formEdit.vehicle.id)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar('Listado de piezas transeferidas descargada!', {
          variant: 'success',
        })
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  const FORM_HOME = (formEdit) => {
    return [
      {
        class: 'textfield',
        name: 'observaciones_estacion_cero',
        label: 'Observación',
        value: formEdit.vehicle.vehiculo_info.observaciones_estacion_cero,
        disabled: true,
        size: 'small',
        sm: 12,
        xs: 12,
        multiline: true,
        rows: 2,
        maxRows: 2,
      },
    ]
  }

  return (
    <div className={classes.root}>
      <div className={classes.table}>
        <BasicTable
          col={[
            { title: '', style: { width: '20px' } },
            { title: 'Código', style: { width: '55px' } },
            { title: 'Pieza', style: { width: '300px' } },
            { title: 'Estado', style: { width: '100px' } },
            { title: 'Ubicación', style: { width: '100px' } },
            { title: 'Almacén', style: { width: '100px' } },
          ]}
          size="small"
          rows={formEdit.stock?.map((row) => {
            return {
              codigo: logo(row.codigo[0]),
              code: row.codigo,
              producto: row.producto,
              estado: row.estado,
              ubicacion: row.ubicacion,
              almacen: row.almacen,
            }
          })}
        />
      </div>
      <div
        style={{
          position: 'sticky',
          bottom: 0,
          background: '#fff',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '16px',
          padding: '10px 20px',
          borderTop: '1px solid #ddd',
          zIndex: 10,
        }}
      >
        <div style={{ flex: 1, width: '70%' }}>
          <InputsWithoutValidate fields={FORM_HOME(formEdit)} spacing={1} />
        </div>
        <CustomButton
          text="PIEZAS TRANSFERIDAS"
          onClick={() => onClick()}
          isLoading={isLoading}
          disabled={isLoading || !edit || !Boolean(formEdit.stock?.length)}
        />
      </div>
    </div>
  )
}

export default Stock
